var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-permission-container" },
    [
      _vm._m(0),
      _c("div", { staticClass: "add-member-btn" }, [
        _c("i", { staticClass: "el-icon-user" }),
        _c("span", { on: { click: _vm.handleAddMemberInit } }, [
          _vm._v("添加指定人"),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.authLoading,
              expression: "authLoading",
            },
          ],
          staticClass: "members-data-list",
        },
        [
          _c("p", { staticClass: "total-person" }, [
            _vm._v(
              " 组织架构 " +
                _vm._s(_vm.orgTotal) +
                " | 角色 " +
                _vm._s(_vm.roleTotal) +
                " | 员工 " +
                _vm._s(_vm.userTotal) +
                " 人 "
            ),
          ]),
          _c(
            "div",
            { staticClass: "member-list-content" },
            _vm._l(_vm.memebersInfoList, function (item) {
              return _c(
                "div",
                { key: item.value + "member", staticClass: "member-list-item" },
                [
                  _c("div", { staticClass: "person-info" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "img",
                          rawName: "v-img",
                          value: item.avatar,
                          expression: "item.avatar",
                        },
                      ],
                      attrs: { alt: "" },
                    }),
                    _c("span", [_vm._v(_vm._s(item.label))]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "permissson-setting" },
                    [
                      _c("PermissionPopover", {
                        attrs: { authType: item.purviewType },
                        on: {
                          changeThePermissionLabel: function ($event) {
                            return _vm.handleSettingPermisson($event, item)
                          },
                          deleteAuthMemberEvent: function ($event) {
                            return _vm.handleDeleteAuthMember(item)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "45%",
            title: "请选择",
            visible: _vm.searchMemberDialogVisible,
            "append-to-body": "",
            "custom-class": "searchMembersDialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.searchMemberDialogVisible = $event
            },
            close: _vm.handleClosedselectDialog,
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "search-by-name" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      multiple: "",
                      filterable: "",
                      remote: "",
                      "default-first-option": "",
                      placeholder: "search",
                      "remote-method": _vm.remoteSearchMethod,
                      loading: _vm.searchLoading,
                      "popper-class": "serachByKeywordDropdown",
                    },
                    on: { change: _vm.handleSelectUser },
                    model: {
                      value: _vm.selectAuthUserList,
                      callback: function ($$v) {
                        _vm.selectAuthUserList = $$v
                      },
                      expression: "selectAuthUserList",
                    },
                  },
                  _vm._l(_vm.searchMemberList, function (item) {
                    return _c(
                      "el-option",
                      {
                        key: item.value + item.label,
                        attrs: { label: item.label, value: item },
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "img",
                              rawName: "v-img",
                              value: item.avatar,
                              expression: "item.avatar",
                            },
                          ],
                          attrs: { alt: "" },
                        }),
                        _c("span", [_vm._v(_vm._s(item.label))]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search-by-other" },
              [_vm.searchMemberDialogVisible ? _c("SelectByEntity") : _vm._e()],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "select-default-auth" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.defaultAuthType,
                    callback: function ($$v) {
                      _vm.defaultAuthType = $$v
                    },
                    expression: "defaultAuthType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("仅可查看")]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("可查看/下载"),
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("可编辑")]),
                  _c("el-radio", { attrs: { label: 4 } }, [_vm._v("可管理")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClosedselectDialog } }, [
                _vm._v("Cancel"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleJumpToAuthSetting },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "permission-title" }, [
      _c("i", { staticClass: "el-icon-user-solid" }),
      _vm._v(" 指定人可访问 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }